<div class="page-wrapper">
    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div><!-- /.sticky-header__content -->
    </div><!-- /.stricky-header -->



    <!--Page Header Start-->
    <section class="page-header">
        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>
        <div class="container">
            <div class="page-header__inner">
                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png" alt="">
                </div>
                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                </div>
                <h3>About Us</h3>
                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li><a href="index.html">Home</a></li>
                        <li><span class="fas fa-angle-right"></span></li>
                        <li>About Us</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <!--Page Header End-->

    <!--About One Start-->
    <section class="about-one">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="about-one__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="about-one__img-box">
                            <div class="about-one__img">
                                <img src="assets/images/resources/x4.png" alt="">
                            </div>
                            <div class="about-one__review-and-experience-box">
                                <div class="about-one__review-box">
                                    <ul class="list-unstyled about-one__review-list">
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-1.jpg" alt="">
                                            </div>
                                        </li>
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-2.jpg" alt="">
                                            </div>
                                        </li>
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-3.jpg" alt="">
                                            </div>
                                        </li>
                                        <li>
                                            <div class="about-one__review-img">
                                                <img src="assets/images/resources/about-one-review-img-1-4.jpg" alt="">
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="about-one__review-star">
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                        <span class="fas fa-star"></span>
                                    </div>
                                    <p class="about-one__review-text">Clients 100+</p>
                                </div>
                                <div class="about-one__experience-box">
                                    <div class="about-one__experience-count">
                                        <h3 class="odometer" data-count="5">5</h3>
                                        <span>+</span>
                                    </div>
                                    <p class="about-one__experience-count-text">Years Of <br> Experience</p>
                                </div>
                                <div class="about-one__video-link">
                                    <a href="#" class="video-popup">
                                        <div class="about-one__video-icon">
                                            <span class="fa fa-play"></span>
                                            <i class="ripple"></i>
                                        </div>
                                    </a>
                                    <h4 class="about-one__video-title">Watch Video</h4>
                                </div>
                            </div>
                            <div class="about-one__circle-text">
                                <div class="about-one__round-text-box">
                                    <div class="inner">
                                        <div class="about-one__curved-circle rotate-me">
                                       Thanvika Enterprises - Udumalpet ★ 999 450 1750 ★
                                        </div>
                                    </div>
                                    <div class="overlay-icon-box">
                                        <a href="about"><i class="icon-plane"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="about-one__shape-1">
                                    <img src="assets/images/shapes/about-one-shape-1.png" alt="">
                                </div> -->
                            <!-- <div class="about-one__shape-2">
                                    <img src="assets/images/shapes/about-one-shape-2.png" alt="">
                                </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="about-one__right">
                        <div class="section-title text-left sec-title-animation animation-style2">
                            <div class="section-title__tagline-box">
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-1">
                                    <i class="fas fa-plane"></i>
                                </div>
                                <h6 class="section-title__tagline">ABOUT US</h6>
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-2">
                                    <i class="fas fa-plane"></i>
                                </div>
                            </div>
                            <h3 class="section-title__title title-animation">THANVIKA <span>ENTERPRISES

                                </span>
                            </h3>
                        </div>
                        <p class="about-one__text">
                            Welcome to Thanvika Enterprises, your trusted partner for high-quality thermal paper rolls,
                            barcode labels, price tags, and customized sticker printing solutions.
                            <br><br>
                            We specialize in supplying premium-quality 2-inch, 3-inch, and 4-inch thermal paper rolls
                            suitable for POS machines, billing printers, barcode printers, and various business
                            applications. We also provide color paper rolls and customized printing solutions to meet
                            the unique requirements of businesses across different industries.
                            <br><br> <b>
                                At Thanvika Enterprises, we offer a wide range of products including:</b>
                        </p>
                        <div class="about-one__point-box">

                        </div>
                        <div class="about-one__point-box-two">
                            <ul class="about-one__point-two">
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>2 Inch Thermal Paper Rolls</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>3 Inch Thermal Paper Rolls</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>4 Inch Thermal Paper Rolls</p>
                                    </div>
                                </li>   <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Color Thermal Paper Rolls</p>
                                    </div>
                                </li>
                            </ul>
                            <ul class="about-one__point-two about-one__point-two--three">
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Barcode Labels</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Printed Color Labels</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Customized Product Labels</p>
                                    </div>
                                </li>   <li>
                                    <div class="icon">
                                        <span class="fas fa-check"></span>
                                    </div>
                                    <div class="text">
                                        <p>Price Tags</p>
                                    </div>
                                </li>
                            </ul> 
                        </div> 
                        <br>
  <p> Thanvika Enterprises – Your Complete Thermal Roll, Barcode Label, and Sticker Printing Solution Partner.</p>
                        <div class="about-one__btn-and-author-box">
                           
                            <div class="about-one__author-box">
                                <div class="about-one__author-details">
                                    <div class="about-one__author-img-box">
                                        <div class="about-one__author-img">
                                            <img src="assets/images/team/team-1-1.jpg" alt="">
                                        </div>
                                    </div>
                                    <div class="about-one__author-content">
                                        <h4> SathishKumar K</h4>
                                        <p>Founder</p>
                                    </div>
                                </div>

                            </div>

                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--About One End-->


 

    <!--Find Transport Start -->
    <section class="find-transport mt-5">
        <div class="find-transport__shape-bg"
            style="background-image: url(assets/images/shapes/find-transport-shape-bg.png);"></div>
        <div class="container">
            <div class="find-transport__inner">
                <div class="find-transport__title-box">
                    <h3 class="find-transport__title">
    Looking for Premium
    <br> Thermal Rolls & Label Solutions?
</h3>
                </div>
                <div class="find-transport__btn-and-call">
                    <div class="find-transport__call-us">
                        <div class="icon">
                            <span class="icon-phone-call"></span>
                        </div>
                        <div class="content">
                            <span>Call Us Free</span>
                            <p><a href="tel:919994501750">+91 999 450 1750</a></p>
                        </div>
                    </div>
                    <div class="find-transport__btn-box">
                        <a href="contact" class="thm-btn">Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Find Transport End -->







    <app-bees-footer></app-bees-footer>




</div><!-- /.page-wrapper -->